import normalizeLink from './normalize-link.js';

function matchArticlePath(articlePath, linkPath) {
  return articlePath === normalizeLink(linkPath);
}

export default matchArticlePath;
